import { getUserLocalization } from "../../js/app/state/appSessionStorage";

const AllTextState: { [key: string]: string } = new Proxy(
  {
  // Dashboard
  dashboard: "Dashboard",
  sideBarColor: "color sidebar",

  // Login
  unauthorized: "Unauthorized",
  wrongIdPassword: "Wrong login-id or password",
  serverError: "Server Error. Try Again Later",

  // navigation
  switchTenant: "Switch Tenant",
  switchOrganization: "Switch Club",

  switchUserRole: "Switch User Role",

  // notification
  createdSuccessfully: "Created Successfully",
  updatedSuccessfully: "Updated Successfully",
  addedSuccessfully: "Added Successfully",
  enableNotificationForRecoveryProgress: "Enable Notification For Recovery Progress",

  // ************** User *************
  user: "User",
  users: "Users",
  userId: "User ID",
  newUser: "New User",
  editUser: "Edit User",
  result: "Result",
  userDetails: "User Details",
  usersReport: "Users Report",
  userManag: "User Management",
  userType: "User Type",
  title: "Title",
  contactNumber: "Contact Number",
  contactNum: "Contact Number",
  mobileNum: "Mobile Number",
  tenantName: "Tenant Name",
  tenantId: "Tenant ID",
  role: "Role",
  roles: "Roles",
  defaultRole: "Default Role",
  active: "Active",
  ACTIVE: "Active",
  inActive: "Inactive",
  INACTIVE: "Inactive",
  setUserActiveOrInactive: "Set User Active/Inactive",
  preferredName: "Preferred Name",
  organizationName: "Club Name",
  organizationAddress: "Club Address",
  Mr: "Mr",
  Mrs: "Mrs",
  Ms: "Ms",
  Miss: "Miss",
  Mx: "Mx",
  Dr: "Dr",
  defaultLoginTenant: "Default Login Tenant",
  companyAdmin: "Company Admin",
  tenantIdsShownHere: "Tenant Ids are shown here",
  contactDetails: "Contact Details",

  defaultTenant: "Default Tenant",
  address: "Address",
  country: "Country",
  state: "State",
  city: "City",  
  employerName: "Employer Name",
  employerCompanyName: "Employer Company Name",
  employerAddress: "Employer Address",
  employerCity: "Employer City",
  employerState: "Employer State",
  employerCountry: "Employer Country",
  employerContactNumber: "Employer Contact Number",
  employerEmailAddress: "Employer Email",

  emailInvitation: "Email Invitation",
  mobileInvitation: "Mobile Invitation",
  resendInvite: "Resend Invite",

  // user roles
  superAdmin: "Super Admin",
  tenantAdmin: "Tenant Admin",
  claimManager: "Case Admin",
  Creator: "Creator",
  organizationAdmin: "Coach",
  orgAdmin: "Coach",
  rehabManager: "Club Associate",
  employer: "Employer",

  super_admin: "Super Admin",
  tenant_admin: "Tenant Admin",
  org_admin: "Coach",
  claim_manager: "Case Admin",
  rehab_manager: "Club Associate",
  claimant: "Player",

  superAdminPermission: "Super Admin",
  tenantAdminPermission: "Tenant Admin",
  otherUser: "Other User",
  returnToWorkManager: "Return To Work Manager (RTW)",
  psychologist: "Psychologist",

  // ************** Organisation *************
  orgs: "Clubs",
  organization: "Club",
  addOrganization: "Add Club",
  newOrganization: "New Club",
  editOrganization: "Edit Club",
  organizationDetails: "Club Details",
  organizationImage: "Club Image",
  organizationId: "Club ID",
  organizations: "Clubs",
  organisations: "Organisations",
  organizationNew: "New Club",
  organizationEdit: "Edit Club",
  abnNum: "ABN",
  contactFirstName: "Contact - First Name",
  contactLastName: "Contact - Last Name",
  organizationType: "Club Type",
  organizationSize: "Club Size",
  postalAddress: "Postal Address",
  residentialAddress: "Residential Address",
  sameAsResidentialAddress: "Same As Residential Address",
  small: "Small < 100",
  medium: "Medium < 500",
  large: "Large > 500",
  timezone: "Time Zone",

  // ----------organization Type --------------------
  HealthInsurance: "Health Insurance",
  HealthCare: "Health Care",
  Roadsafety: "Road Safety",
  Transportation: "Transportation",
  Telecom: "Telecom",
  Manufacturing: "Manufacturing",
  RetailAndLeisure: "Retail and Leisure",
  Banking: "Banking",
  Government: "Government",
  Construction: "Construction",
  FoodManufacturing: "Food Manufacturing",
  Farming: "Farming",
  Pharmacy: "Pharmacy",
  Aerospace: "Aerospace",
  InformationTechnology: "Information Technology",
  ArmedForces: "Armed forces",
  Education: "Education",

  // ********** Claim ******************
  RTPCases: "RTP Cases",
  RTWCases: "RTW Cases",
  RTWClaims: "RTW Claims",
  clinicalClaims: "Clinical Claims",
  RTWClaimsManagement: "RTW Claims Management",
  clinicalCaseManagement: "Clinical Case Management",
  chargeAmountAUD: "Charge Amount (AUD)",
  claimsAssociation: "Case Association",
  caseNoteAssoication: "Shared With",
  associatedUsers: "Associated Users",
  claimAssociatedUsers: "Case Associated Users",
  practitionerRegistrationNumber: "Practitioner Registration Number",

  planForTraining: "Plan for Training",
  planForTrainingType: "Plan for Training Types",
  planForTrainingNote: "Plan for Training Note",
  estimatedRTP: "Estimated RTP",
  estimatedRTW: "Estimated RTW",
  date: "Date",

  trafficLightStatus: 'Traffic Light Status',
  tls: '',

  interventionMode: "Intervention Mode",
  dateOfInjury: "Date of Injury",
  dateOfClaimReceived: "Date of Case Received",
  employerReceiveDate: "Date of Case Received",
  employerSubmitDate: "Date of Case Submitted",
  dateOfClaimSubmitted: "Date of Case Submitted",
  dateOfClaimClaimSubmitted: "Date of Claim Submitted",
  dateOfClaimSubmission: "Date of Case Submission",
  dateOfInjuryStatus: "Date of Injury Status",
  dateOfInitialDiagnosis: "Date of Initial Diagnosis",
  injuryType: "Injury Region",
  injuryOrIllness: "Injury / Illness",
  injuryDescription: "Injury Description",
  natureOfInjury: "Nature of Injury",
  otherNatureOfInjury: "Specify the Nature of Injury",
  treatmentCommence: "Treatment Commence",
  treatmentComplete: "Treatment Complete",
  estimatedTreatmentComplete: "Estimated Treatment Complete",
  dateOfServiceStatus: "Date of Service Status",
  dateOfServiceTo: "Date of Service To",
  dateOfServiceFrom: "Date of Service From",
  totalNumOfService: "Total Number of Services",
  insurerInfo: "Insurer Information",

  injuryInfo: "Injury Information",
  hospitalInfo: "Hospital Information",
  providerInfo: "Provider Information",
  specialistInfo: "Specialist Information",
  serviceInfo: "Service Information",

  claim: "Case",
  claims: "Cases",
  cases: "Cases",
  newClaim: "New Case",
  newRTPCase: "New RTP Case",
  claimEdit: "Case Edit",
  editClaim: "Edit Case",
  claimManagement: "Claim Management",
  caseManagement: "Case Management",
  claimNumber: "Case Number",
  claimId: "Case ID",
  useCaseName: "Use Case",
  useCases: "Use Cases",
  useCaseDetails: "Use Case Details",
  useCaseEdit: "Use Case Edit",
  claimDetails: "Case Details",
  claimLine: "Case Line",
  addClaim: "Add Case",
  dateOfLodgement: "Date of Lodgement",
  healthCareId: "Health Care ID",
  companyName: "Company Name",
  employeeId: "Employee ID",
  employeeContactNumber: "Employee Contact Number",

  dob: "Date of Birth",
  gender: "Gender",
  secondaryEmail: "Secondary Email",
  dayTimeContactNumber: "Day Time Contact Number",
  dayTimeContactNum: "Day Time Contact Number",
  mobileNumber: "Mobile Number",

  serviceType: "Service Type",
  serviceDescription: "Service Description",
  natureOfService: "Nature of Service",
  totalService: "Total Service",
  dateOfService: "Date of Service",
  chargeAmount: "Charge Amount",
  providerNumber: "Provider Number",
  providerNum: "Provider Number",
  providerName: "Provider Name",
  providerContactNumber: "Provider Contact Number",
  providerContactNum: "Provider Contact Number",

  hospitalName: "Hospital Name",
  hospitalContactNum: "Hospital Contact Number",
  hospitalAddress: "Hospital Address",
  providerAddress: "Provider Address",
  specialist: "Specialist",
  specialistContactNumber: "Specialist Contact Number",
  rehabSpecialist: "Rehab Specialist",
  rehabSpecialistContactNumber: "Rehab Specialist Contact Number",
  rehabSpecialistAddress: "Rehab Specialist Address",
  rehabSpId: "Specialist ID",
  rehabSpName: "Specialist Name",
  rehabSpContactNum: "Specialist Contact Number",
  rehabSpAddress: "Specialist Address",

  specialistId: "Specialist ID",
  specialistName: "Specialist Name",
  specialistContactNum: "Specialist Contact Number",
  specialistAddress: "Specialist Address",

  employerInfo: "Employer Information",
  claimantDetails: "Player Details",
  serviceDetails: "Service Details",
  claimStatus: "Case Status",
  useCaseStatus: "Use Case Status",
  claimLineStatus: "Case Line Status",
  ModeOfOnset: "Mode of onset",
  InjuryMode: "Was the mode",
  MechanismForSuddenOnset: "Mechanism For Sudden Onset",
  InjuryCategory: "Injury Category",
  statusReason: "Status Reason",
  playerAvailability: "Player Availability",

  approved: "Approved",
  rejected: "Rejected",
  furtherInfoRequired: "Further Information Required",
  open: "Open",
  closed: "Closed",
  closedReason: "Closed Reason",
  rejectReason: "Reject Reason",
  requestedInformation: "Requested Information",
  serviceCategory: "Service Category",
  interventionType: "Intervention Type",
  service: "Service",
  services: "Services",
  ModeOfMeeting: "Mode of Meeting",
  virtual: "Virtual",
  faceToFace: "Face to Face",
  location: "Location",
  attachments: "Attachments",
  reason: "Reason",

  uploadFiles: "Upload Files",
  files: "Files",

  injuryInformation: "Injury Information",
  illnessInformation: "Illness Information",
  relationshipToSport: "Relationship to sports activity",
  illnessType: "Illness Category",

  serviceInformation: "Service Information",
  hospitalInformation: "Hospital Information",
  providerInformation: "Provider Information",
  specialistInformation: "Specialist Information",

  caseNotes: "Case Notes",
  notes: "Notes",
  addNewNote: "Add New Note",
  editNotes: "View / Share Case Notes",
  viewNotes: "View Case Notes",
  defaultCoach: "Default Coach",
  defaultOrgAdmin: "Default Coach",
  // ************** claimant ******************

  // ************** Tenant *************
  tenant: "Tenant",
  tenants: "Tenants",
  tenantType: "Tenant Type",
  tenantTypes: "Tenant Types",
  tenantsByTenantType: "Tenants By Tenant Type",
  newTenant: "New Tenant",
  editTenant: "Edit Tenant",
  tenantDetails: "Tenant Details",
  tenantManagement: "Tenant Management",
  tenantImage: "Tenant Image",
  Image: "Image",
  tenantLogo: "Tenant Logo",
  tenantBackground: "Tenant Background",
  tenantList: "Tenant List",
  tenantTypeId: "Tenant Type",

  // --user table
  professionalTitle: "Professional Title",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  playerName: "Player Name",
  email: "Email",
  status: "Status",
  recoveryStatus: "Recovery Status",

  // Report
  report: "Report",
  reports: "Reports",
  userReport: "User Report",
  tenantReport: "Tenant Report",
  trackingReport: "Tracking Report",
  organizationReport: "Club Report",
  rtpClaimsReport: "RTP Cases Report",
  rtwClaimsReport: "RTW Cases Report",
  clinicalClaimsReport: "Clinical Claims Report",

  // Report Table
  banner: "Banner",
  trackingEvent: "Tracking Event",
  trackClicksPerBanner: "Clicks",
  tenantOrganisation: "Tenant, Organisation",
  ageRange: "Age Range",

  // ********* Care Network ********
  partner: "partner",
  Partner: "Partner",

  // ********* Chat ********
  chat: "Chat",
  newChat: "New Chat",
  chats: "Chats",
  group: "Group",
  newGroup: "New Group",
  newChatGroup: "New Chat Group",
  chatInfo: "Chat Info",
  groupInfo: "Group Information",

  // *************** react table *************
  details: "Details",
  noData: "No Data Found",
  action: "Action",

  // ************ Recovery Progress ***********
  scaleType: "Scale Type",
  painScale: "Pain Scale",
  moodScale: "Mood Scale",
  recoveryProgress: "Recovery Progress",
  recoveryProgressDetails: "Recovery Progress Details",
  veryLow: "Very Low",
  low: "Low",
  average: "Average",
  high: "High",
  veryHigh: "Very High",
  veryGood: "Very Good",
  good: "Good",
  comments: "Comments",
  comment: "comment",
  morningComments: "Morning Comments",
  eveningComments: "Evening Comments",

  // ************ Appointment ******************
  appointments: "Appointments",
  appointment: "Appointment",
  appointmentCalender: "Appointment Calendar",
  newAppointment: "New Appointment",
  appointmentDetails: "Appointment Details",
  AppointmentEdit: "Appointment Edit",

  description: "Description",
  mode: "Mode",
  participants: "Participants",
  additionalParticipants: "Additional Participants",
  caseStaff: "Case Staff",
  Time: "Time",
  isClaimantPartOfAppointment: "Is Player part of this Appointment?",
  online: "Online",
  inPerson: "In Person",
  startDatetime: "Start Time",
  endDatetime: "Ends At",
  toHour: "Hours",
  toMinutes: "Minutes",

  // ************* bulk upload ***************
  bulkUpload: "Bulk Upload",
  createBulkUser: "Create Bulk User",
  uploadCsv: "Upload CSV",
  downloadCSVTemplate: "Download CSV Template",
  downloadSampleDataSheet: "Download Sample Data Sheet",
  csvRow: "CSV Row",

  downloadCSVTemplateEndUser: "End User CSV Template",
  downloadCSVTemplateManager: "Manager CSV Template",
  downloadCSVTemplateCaseManager: "Case Manager CSV Template",
  downloadCSVTemplateCoach: "Coach CSV Template",
  downloadCSVTemplateTenantAdmin: "Tenant Admin CSV Template",

  downloadSampleDataSheetEndUser: "End User Sample Data",
  downloadSampleDataSheetManager: "Manager Sample Data",
  downloadSampleDataSheetCaseManager: "Case Manager Sample Data",
  downloadSampleDataSheetCoach: "Coach Sample Data",
  downloadSampleDataSheetTenantAdmin: "Tenant Admin Sample Data",

  uploadEndUser: "Upload End User",
  uploadManager: "Upload Manager",
  uploadCoach: "Upload Coach",
  uploadTenantAdmin: "Upload Tenant Admin",


  // ****************** survey *****************
  survey: "Survey",
  surveyTitle: "Survey",
  surveyDashboard: "Dashboard",
  summary: "Summary",
  surveyStatistics: "Survey Statistics",
  questionsStats: "Questions Data",
  surveyData: "Survey Data",
  priority: "Priority",
  groupId: "Group ID",
  qid: "qid",
  category: "Category",
  allowAddComment: "Allow to add comment",
  allowAddCommentText: "Player can add comment to this question",
  questionaryStatus: "Questionnaire status",
  operationalStatus: "Operational Status",
  allowedToComment: "Allowed to Comment",
  history: "History",
  surveyReports: "Survey Reports",
  questionDetails: "Question Details",

  from: "From",
  to: "To",

  questionnaire: "Questionnaire",
  questionnaires: "Questionnaires",
  newQuestionnaires: "New Questionnaires",
  editQuestionnaires: "Edit Questionnaires",
  question: "Question",
  newQuestion: "New Question",
  questionStatus: "Question Status",
  questions: "Questions",
  answerType: "Answer Type",
  answer: "Answer",
  importance: "Importance",

  surveyGroup: "Group",
  groups: "Groups",
  groupDetails: "Group Details",
  numberOfQuestions: "Number of Questions",
  updateQuestionnaires: "Update Questionnaires",
  maxQuestionnaires: "Max Questions",
  eventType: "Event Type",
  numOfQuestions: "Total questions",
  minCategoryValidation: "At least 1 category is required ",
  minQuestionsValidation: "At least 1 question is required ",
  maxQuestionsValidation: "Maximum 15 questions are allowed",

  surveyEvent: "Event",
  events: "Events",
  newEvent: "New event",
  eventDetails: "Event Details",
  eventQuestions: "Event Questions",
  startDate: "Start date",
  frequency: "Frequency",
  repeatCount: "Repeat count",
  surveyValidity: "Survey Validity",
  responseType: "Response Type",
  eventId: "Event ID",
  enableSurvey: "Enable survey",
  requestSurvey: "Request survey",
  enableSurveyTooltip: "Enable survey will trigger Survey for Player",

  surveyRef: "Survey Ref",
  enableDate: "Enable Date",
  endDate: "End Date",
  refId: "Reference ID",
  surveyEventType: "Event Type",
  takeSurvey: "Take Survey",
  eventExecutionId: "Event Execution ID",

  // ****************** password *****************
  password: "Password",
  newPassword: "New Password",

  oneLowerCharacter: "One LowerCase Character",
  oneUpperCharacter: "One UpperCase Character",
  oneSpecialChar: "One Special Character",
  oneNumberChar: "One Number",
  changeAccountPassword: "Change Your Account Password",
  changePassword: "Change Password",
  passwordTooShort: "Password Too Short - should be 8 chars minimum",
  passwordTooLarge: "Password Too Large - should no exceed 32 chars",

  currentPassword: "Current Password",
  reEnterPassword: "Enter Password Again",
  reEnterNewPassword: "Re-Enter New Password",
  passwordMatch: "Password Must Match",
  passwordIsSameAsOld: "Password Is Same As Old Password, Please Enter New Password",
  passwordChanged: "Password Changed",


  // system Preference
  systemPreference: "System Preference",
  timeZone: "Time Zone",
  chooseDeviceType: "Choose Device Type",

  notificationPreference: "Notification Preference",

  // website
  webName: "Case Management Solution",
  webName2: "MiRa by SD",

  // footerName: `©${}Powered By EtherSys`,
  platformManagement: "Platform Management",
  notPermitted: "You are not permitted to perform that action",

  // form
  name: "Name",
  type: "Type",
  size: "Size",
  link: "Link",
  website: "Website",
  required: "Required",
  isRequired: "Is Required",
  areRequired: "Are Required",
  notValid: "Not Valid",
  changeIcon: "Change Icon",
  denotedRequired: "Denotes a required field",
  maxChar255: "Must be no longer than 255 characters",
  maxChar2500: "Must be no longer than 2500 characters",
  maxChar50: "Must be no longer than 50 characters",
  maxChar15: "Must be no longer than 15 characters",
  maxChar24: "Must be no longer than 24 characters",
  minChar5: "Must be longer than 5 characters",
  defaultOrg: "Default Club",
  dropdownPlaceHolder: "Select . . .",
  datetime: "Date and Time",
  timestamp: "Timestamp",
  note: "Note",

  // table
  Details: "Details",
  createdBy: "Created By",
  createdAt: "Created At",
  updatedBy: "Updated By",
  updatedAt: "Updated At",
  viewMore: "View More",

  // btn
  add: "Add",
  edit: "Edit",
  submit: "Submit",

  // common
  activeOrInActive: "Active/InActive",
  id: "ID",

  // dummy
  ibm: "IBM",
  wipro: "Wipro",

  qwe: "IMS100.01",
  asd: "IMS100.02",

  tenant1: "Tenant 1",
  tenant2: "Tenant 2",

  // club
  clubName: "Club Name",
  club: "Club",
  clubs: "Clubs",
  defaultClub: "Default Club",
  addClub: "Add Club",
  clubManagement: "Club Management",
  clubId: "Club ID",
  clubImage: "Club Image",
  clubDetails: "Club Details",
  newClub: "New Club",
  editClub: "Edit Club",
  clubReport: "Club Report",

  // Case
  case: "Case",
  caseAdmin: "Case Admin",

  // coach
  coach: "Coach",


  // Chart titles
  totalInjuryIllnessChartByAge: "Total Injuries and Illnesses - By Age",
  totalInjuryIllnessChartByGender: "Total Injuries and Illnesses - By Gender",
  typesOfInjuryIllnessChart: "Types of Injuries and Illnesses",
  typesOfNatureOfInjuryChart: "Types of Nature of Injury",
  averageRTPChartByAge: "Average RTP - By Age",
  averageRTWChartByAge: "Average RTW - By Age",
  averageRTPChartByGender: "Average RTP - By Gender",
  averageRTWChartByGender: "Average RTW - By Gender",
} as { [key: string]: string },
{
  get: function (target, prop: string) {
    // Check sessionStorage localization first
    const localization = getUserLocalization();
    if (localization && localization[prop]) {
      return localization[prop]; // Return the localized value if it exists
    }
    // Otherwise, fall back to the default value in AllTextState
    return target[prop];
  }
});


export default AllTextState
